import React, { useRef } from "react";
import { Button, Table } from "react-bootstrap";
import "./ParcelPreviewPdf.css"; // CSS below

const ParcelPreviewPdf = ({
  addressData = [],
  groupBy = "none",
  setIsPrintSelect,
}) => {
  const parcelRef = useRef(null);

  const groupByStreet = () => {
    return addressData.reduce((acc, curr) => {
      const key = curr.streetName || "Unknown";
      if (!acc[key]) acc[key] = [];
      acc[key].push(curr);
      return acc;
    }, {});
  };

  const groupBySize = () => {
    return {
      Big: addressData.filter((item) => item.isBig),
      Small: addressData.filter((item) => !item.isBig),
    };
  };

  const renderTable = (title, data) => (
    <div className="table-wrapper" key={title}>
      <h6 className="text-center">{title}</h6>
      <Table striped bordered className="table-sm mb-0 tabel-small-font">
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>Address</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.s_number}</td>
              <td>{item.address}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );

  const renderContent = () => {
    if (groupBy === "street") {
      const grouped = groupByStreet();
      return Object.entries(grouped).map(([street, items]) =>
        renderTable(street, items)
      );
    } else if (groupBy === "size") {
      const grouped = groupBySize();
      return Object.entries(grouped).map(([size, items]) =>
        renderTable(size + " Parcel", items)
      );
    } else {
      const chunkSize = 15;
      const tables = [];
      for (let i = 0; i < addressData.length; i += chunkSize) {
        const chunk = addressData.slice(i, i + chunkSize);
        tables.push(
          renderTable(`Parcel ${i + 1} - ${i + chunk.length}`, chunk)
        );
      }
      return tables;
    }
  };

  const handleGeneratePDF = async () => {
    const element = parcelRef.current;

    // If using CDN, html2pdf is on window
    const html2pdf = (await import("html2pdf.js")).default || window.html2pdf;

    // A4 size: 210mm x 297mm, leave margins by jsPDF unit
    const timestamp = new Date().toISOString();
    const opt = {
      margin: [10, 10, 10, 10], // top, left, bottom, right in mm
      filename: `parcel_${timestamp}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 3, // better text quality
        useCORS: true,
        letterRendering: true,
        ignoreElements: (el) => el.classList?.contains("no-print"),
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        compress: true,
      },
      pagebreak: {
        mode: ["css", "legacy"], // respects CSS page-break rules
        avoid: ["tr", ".avoid-break"], // avoid breaking rows
      },
    };

    await html2pdf().from(element).set(opt).save();
  };

  return (
    <>
      <div className="d-flex w-100 justify-content-end px-4 gap-3">
        <Button
          variant="success"
          className="mb-3 mt-2"
          onClick={handleGeneratePDF}
          //disabled={isGeneratingPDF}
        >
          {"Download"}
        </Button>
        <Button
          variant="dark"
          className="mb-3 mt-2"
          onClick={() => setIsPrintSelect(false)}
          //disabled={isGeneratingPDF}
        >
          {"Close"}
        </Button>
      </div>
      <div className="print-grid" ref={parcelRef}>
        {renderContent()}
      </div>
    </>
  );
};

export default ParcelPreviewPdf;
